import './vscode/src/vs/workbench/contrib/relauncher/browser/relauncher.contribution.js';

function getServiceOverride() {
    return {};
}

export { getServiceOverride as default };
